import React from 'react';
import '../App.css';

function About(props) {
    const text = `Part of the reason I love coding is the opportunity it affords to learn something new every day. I'm committed to being a life long learner and understand that practice is the easiest way to get better quickly at any skill. Hence I am committing myself to building 30 websites every day for the next 30 days. I won't hold myself to any unrealistic promises. I'm not expecting to complete each and every site in it's entirety from start to finish. I do aim though to get a good dent in each and stay committed to returning to and completing projects fully ASAP. \n
    Since the crux of my job as front end developer is to transform a vision into code, a few of these projects will actually be replications of other sites I see or admire. I promise I'm not being lazy though and this is all in the spirit of learning. On principal with these sorts of projects, I don't peek at the HTML or CSS since that defeats the whole purpose of learning new skills. Rather, the challenge lies in having to create code from scratch to achieve a specified look and functionality. I'll always note which projects are replications and provide a link to the original source site. \n
    I'm currently open to new opportunities! Feel free to send me a buzz at berniriscoleman@gmail.com.`
  return (
  <div>
    <div className="container">
    <div className="flex">
    <div className="infobox-1 about">
    <h1>Why 30 Websites in 30 Days?</h1>
    <p className="display-linebreak">{text}</p>
    </div>
    </div>
    </div>
    <footer></footer>
</div>
    );
  }
export default About;